<div *ngIf="filterNav?.refinementType === 'RefinementMenu'">
  <app-usf-expandable-panel
    title="{{ filterNav.displayName }}"
    [collapseContent]="!filterNav.isExpended"
  >
    <div class="refinement-section">
      <div
        [attr.data-cy]="'refinement-menu-' + x + '-section'"
        *ngFor="let filter of filterNav.staticRefinements; let x = index"
      >
        <div class="form-check custom-checkbox pb-1">
          <input
            type="checkbox"
            [attr.data-cy]="'refinement-menu-' + x + '-checkbox'"
            class="form-check-input custom-control-input"
            [checked]="filter.selected === true"
            name="chkboxBrands"
            id="{{ filter.selectedFilter }}"
            (click)="selectMenuItems(filter, false)"
          />
          <label
            for="{{ filter.selectedFilter }}"
            [attr.data-cy]="'refinement-menu-' + x + '-label'"
            class="form-check-label custom-control-label"
            title="{{ filter.displayName | titlecase }}"
          >
            {{ filter.displayName | titlecase }}
          </label>
        </div>
      </div>

      <ng-container *ngIf="filterNav.displayName === filterNavType.Allergens">
        <div class="allergen-text" data-cy="refinement-menu-allergen-text">
          {{ 'i18n.search.searchFilters.allergenText' | translate }}
        </div>
        <div class="allergen-disclaimer">
          <span data-cy="refinement-menu-allergen-disclaimer-text">{{
            'i18n.search.searchFilters.importantInformation' | translate
          }}</span>
          <ion-icon
            name="information-circle-outline"
            data-cy="refinement-menu-icon-show-disclaimer"
            (click)="showDisclaimer($event)"
          ></ion-icon>
          <img src="assets/images/triangle.svg" class="triangle" #triangle />
          <ng-template #disclaimerDialog>
            <div
              data-cy="refinement-menu-container-hide-disclaimer"
              [innerHTML]="'i18n.search.searchFilters.important' | translate"
            ></div>
          </ng-template>
        </div>
      </ng-container>

      <div
        *ngFor="
          let filter of filterRefinements | slice: 0:itemsToShow;
          let i = index
        "
      >
        <ng-container *ngIf="!filterNav.categoryLink; else noLink">
          <div class="form-check custom-checkbox">
            <span
              [attr.data-cy]="'refinement-menu-' + i + '-checkbox'"
              (click)="selectMenuItems(filter, false)"
              class="category-link row"
            >
              <div
                class="outer-dot"
                [ngClass]="{ selected: filter.selected === true }"
                [attr.data-cy]="'refinement-menu-' + i + '-dot'"
                [id]="filter.dimensionId"
                #categoryIds
              >
                <span class="dot"></span>
                <img src="assets/images/filter-selected.svg" class="selected" />
                <img src="assets/images/filter-hover.svg" class="hover" />
                <img
                  *ngIf="filterNav.filterName === 'Product Ratings'"
                  class="star-ratings-image"
                  [src]="getImageUrl(filter)"
                />
              </div>
              <span [attr.data-cy]="'refinement-menu-' + i + '-label-name'"
                >{{
                  filterNav.displayName === 'Delivery Method'
                    ? filter.displayName
                    : (filter.displayName | titlecase)
                }}
                <span
                  *ngIf="filter.count"
                  [attr.data-cy]="'refinement-menu-' + i + '-label-count'"
                  class="numberText"
                  >({{ filter.count }})</span
                ></span
              >
            </span>
          </div>
        </ng-container>
        <ng-template #noLink>
          <span
            [attr.data-cy]="'refinement-menu-' + i + '-select-menu-item'"
            (click)="selectMenuItems(filter, true)"
            class="category-link row"
          >
            <div
              class="outer-dot"
              [id]="filter.dimensionId"
              #categoryIds
              [attr.data-cy]="'refinement-menu-' + i + '-dot'"
            >
              <span class="dot"></span>
              <img src="assets/images/filter-hover.svg" class="selected" />
              <img src="assets/images/filter-hover.svg" class="hover" />
            </div>
            <span [attr.data-cy]="'refinement-menu-' + i + '-label-name'"
              >{{ filter.displayName | acronymTitleCase }}
              <span
                *ngIf="filter.count"
                class="numberText"
                [attr.data-cy]="'refinement-menu-' + i + '-label-count'"
                >({{ filter.count }})</span
              ></span
            >
          </span>
        </ng-template>
      </div>
      <div
        class="view-more-container"
        data-cy="refinement-menu-toggle-refinement-view"
        *ngIf="filterRefinements?.length > DEFAULT_SHOW"
        (click)="toggleRefinementView()"
      >
        <div class="view-more" data-cy="refinement-menu-text-view">
          {{
            itemsToShow > DEFAULT_SHOW
              ? ('i18n.common.viewLess' | translate)
              : ('i18n.common.viewMore' | translate)
          }}
        </div>
        <ion-icon
          name="chevron-down-outline"
          data-cy="refinement-menu-icon-down"
          class="chevron"
          *ngIf="itemsToShow <= DEFAULT_SHOW"
        ></ion-icon>
        <ion-icon
          name="chevron-up-outline"
          data-cy="refinement-menu-icon-up"
          class="chevron"
          *ngIf="itemsToShow > DEFAULT_SHOW"
        ></ion-icon>
      </div>
    </div>
  </app-usf-expandable-panel>
</div>
